var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondoFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 360,
    viewBox: "0 0 1728 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_725)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 360,
    fill: "#0B0D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000151175 36C0.000164069 8.38574 22.3859 -14 50.0001 -14H1678C1705.61 -14 1728 8.38578 1728 36L1728 359.743H0L0.000151175 36Z",
    fill: "#0B0D81"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_113_725)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1672,
    cy: 272,
    r: 178,
    fill: "#91DDCF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_113_725",
    x: 1194,
    y: -206,
    width: 956,
    height: 956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_113_725"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 360,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoFooter);
export default __webpack_public_path__ + "static/media/fondo_footer.1d25d8ebcea697f851c1fcf132c5bb73.svg";
export { ForwardRef as ReactComponent };